import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="GrantsNotes" link="https://grants-notes.herokuapp.com" bg="linear-gradient(to right, #ee0979 0%, #ff6a00 100%)" mdxType="ProjectCard">
  React + Material UI deployed on Firebase.
    </ProjectCard>
    <ProjectCard title="OPP Workout Tool" link="https://github.com/calec" bg="linear-gradient(to right, #41C02A 0%, #0084CA 100%)  " mdxType="ProjectCard">
  Fitness Tracking App - In Development
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      